import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { HomeSegment, HomeState } from '../types';

/**
 * Home store for managing Send/Deliver segment state
 * Persists to localStorage to remember user's last selected mode
 */
export const useHomeStore = create<HomeState>()(
  persist(
    (set) => ({
      segment: 'send' as HomeSegment,
      setSegment: (segment: HomeSegment) => set({ segment }),
    }),
    {
      name: 'jetpacker-home',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// Selector hooks
export const useHomeSegment = () => useHomeStore((state) => state.segment);
export const useSetHomeSegment = () => useHomeStore((state) => state.setSegment);
